import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UserInfo } from '@app/store/models/session.model';
import { FormlyFieldConfig } from '@ngx-formly/core';

export const ONLY_8_NUMBERS_REGEX = /^\d{8}$/;
export const ONLY_6_NUMBERS_REGEX = /^\d{6}$/;

export const PASSWORD_CHARS_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*():;<>[\]{}_+=|\\/?.,-]).{8,}/; // Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:
export const AVOID_REPEATED_CHARS_REGEX = /^(?!.*(.)\1{1,}).+$/; // Not allowed repead sequence chars

export const PASSWORD_MINOSSE_REGEX = /^[a-zA-Z0-9]{8,}$/; // Minimum eight characters,only letters and numbers, NO special chars
export const LETTERS_AND_NUMBERS_REGEX = /^[a-zA-Z0-9]{8,}$/; // Minimum eight characters,only letters and numbers, NO special chars

// write a regex to check is string contains only alphanumeric characters and minimum 8 characters, not allowed special characters
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

const CODICE_FISCALE_REGEX =
  /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9A-Z]{3}[A-Z]$/;

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

// Validatore blando per numeri di telefono: solo cifre (supporta anche 9 cifre)
export const PHONE_NUMBER_REGEX = /^\d{9,15}$/;
export const strenghtPasswordValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const passwordValue: string = control.value;
  if (!passwordValue) {
    return null;
  }
  // Se non ha ancora raggiunto la lunghezza minima, lasciamo che sia minlength
  // a gestire il messaggio mostrato al submit.
  if (passwordValue.length < 8) {
    return null;
  }

  const isStrenght = PASSWORD_CHARS_REGEX.test(passwordValue);
  if (!isStrenght) {
    //return { isNotStrenght: true };
  }
  const hasNotRepeatingChars = AVOID_REPEATED_CHARS_REGEX.test(passwordValue);

  if (!hasNotRepeatingChars) {
    //return { hasRepeatingChars: true };
  }

  console.log('🚀 ~ return ~ isStrenght', {
    isStrenght,
    hasNotRepeatingChars,
  });
  const isValid = isStrenght && hasNotRepeatingChars;
  return !isValid ? { PASSWORD_STRENGHT: true } : null;
};

export const strenghtPasswordMinosse = (
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: { user: UserInfo }
): ValidationErrors | null => {
  console.log('🚀 ~ options', options);
  const passwordValue: string = control.value;
  if (!passwordValue) {
    return null;
  }

  if (options?.user) {
    if (
      passwordValue.toLowerCase().includes(options.user.username.toLowerCase())
    ) {
      return { PASSWORD_STRENGHT_MINOSSE: true };
    }
  }

  const isStrenght = PASSWORD_MINOSSE_REGEX.test(passwordValue);

  return !isStrenght ? { PASSWORD_STRENGHT_MINOSSE: true } : null;
};

export const pinPukValidator = (
  control: AbstractControl
): ValidationErrors | null => {
  const pinPuk = control.value;
  if (!pinPuk) {
    return null;
  }

  const is8digits = ONLY_8_NUMBERS_REGEX.test(pinPuk);

  return !is8digits ? { PIN_PUK_VALIDATOR: true } : null;
};

export const otpValidator = (
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: { lenght: number } = { lenght: 8 }
): ValidationErrors | null => {
  const pinPuk = control.value;
  if (!pinPuk) {
    return null;
  }

  const { lenght = 8 } = options;
  console.log('🚀 ~ options', options);
  if (lenght == 6) {
    const is6digits = ONLY_6_NUMBERS_REGEX.test(pinPuk);
    return !is6digits ? { PIN_PUK_VALIDATOR: true } : null;
  } else if (lenght == 8) {
    const is8digits = ONLY_8_NUMBERS_REGEX.test(pinPuk);
    return !is8digits ? { PIN_PUK_VALIDATOR: true } : null;
  }

  return null;
};

export function strenghtPasswordValidator(): ValidatorFn {
  return strenghtPasswordValidatorFn;
}

export function validEmailValidator(control: AbstractControl) {
  const email = control.value;
  if (!email) {
    return null;
  }
  console.log('🚀 ~ email', email);
  const isValid = EMAIL_REGEX.test(email);
  return !isValid ? { VALID_EMAIL: true } : null;
}

export function validPassphraseValidator(control: AbstractControl) {
  const pass = control.value;
  if (!pass) {
    return null;
  }
  console.log('🚀 ~ pass', pass);
  const isValid = LETTERS_AND_NUMBERS_REGEX.test(pass);
  return !isValid ? { VALID_PASSPHRASE: true } : null;
}

export function sameFieldsValidator(
  control1: string,
  control2: string
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const p1 = control.get(control1)?.value;

    const p2 = control.get(control2)?.value;

    if (!!p1 && !!p2) {
      if (p1 !== p2) {
        return { samePassword: true };
      }
    }

    return null;
  };
}

export function differentPinValidator(
  control1: string,
  control2: string
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const p1 = control.get(control1)?.value;

    const p2 = control.get(control2)?.value;

    if (!!p1 && !!p2) {
      if (p1 == p2) {
        return { DIFFERENT_PIN: true };
      }
    }

    return null;
  };
}

export function fieldMatchValidator(control: AbstractControl) {
  const { password, passwordConfirm } = control.value;

  // avoid displaying the message error when values are empty
  if (!passwordConfirm || !password) {
    return null;
  }

  if (passwordConfirm === password) {
    return null;
  }

  return { fieldMatch: { message: 'Password Not Matching' } };
}

//controlla che la nuova password sia diversa dalla precedente
export function sameOldPassword(control: AbstractControl) {
  const { oldPassword, newPassword } = control.value;

  if (!oldPassword || !newPassword) {
    return null;
  }

  //Errore Se la nuova password è uguale alla precedente
  if (oldPassword == newPassword) {
    return { SAME_OLD_PASSWORD: true };
  } else {
    return null;
  }
}

//controlla che la nuova password sia diversa dalla precedente
export function samePinAndPuk(control: AbstractControl) {
  const { newPin, puk } = control.value;

  if (!puk || !newPin) {
    return null;
  }

  //Errore Se la nuova password è uguale alla precedente
  if (newPin == puk) {
    return { SAME_PIN_PUK: true };
  } else {
    return null;
  }
}

//controlla che le nuove password inserite siano identiche
export function SameNewAndConfirmPassword(control: AbstractControl) {
  const { newPassword, confirmPassword } = control.value;

  // avoid displaying the message error when values are empty
  if (!newPassword || !confirmPassword) {
    return null;
  }

  // Mismatch visibile solo quando il campo di conferma ha raggiunto la lunghezza minima.
  if ((confirmPassword as string).length < 8) {
    return null;
  }

  //Se la nuove password non sono uguali
  if (newPassword != confirmPassword) {
    return { SAME_PASSWORD: true };
  }
  return null;
}

export function SamePinAndConfirmPin(control: AbstractControl) {
  const { newPin, confirmPin } = control.value;

  // avoid displaying the message error when values are empty
  if (!newPin || !confirmPin) {
    return null;
  }

  // Mostra l'errore di mismatch solo quando il campo conferma ha raggiunto
  // almeno la lunghezza minima prevista (minLength=8).
  // Così durante la digitazione non appare il messaggio finché il dato non è "completo".
  if (
    (newPin as string).length < 8 ||
    (confirmPin as string).length < 8
  ) {
    return null;
  }

  if (newPin != confirmPin) {
    return { SAME_PIN: true };
  }
  return null;
}

export const getPasswordFields = (
  isChangePassword: boolean = false
): FormlyFieldConfig[] => {
  let validation = [
    { name: 'SAME_PASSWORD', options: { errorPath: 'confirmPassword' } },
  ];

  if (isChangePassword) {
    validation = [
      { name: 'SAME_OLD_PASSWORD', options: { errorPath: 'newPassword' } },
      ...validation,
    ];
  }

  let fieldGroup: FormlyFieldConfig[] = [
    {
      key: 'newPassword',
      type: 'ic1-text',
      className: 'ic1-col-12 ic1-col-lg-6',

      validators: {
        validation: ['PASSWORD_STRENGHT'],
      },
      props: {
        type: 'password',
        label: 'HEADER.CHANGE_PWD.NEW_PWD_LABEL',
        placeholder: 'HEADER.CHANGE_PWD.NEW_PWD_PLACEHOLDER',
        required: true,
      },
    },
    {
      key: 'confirmPassword',
      type: 'ic1-text',
      className: 'ic1-col-12 ic1-col-lg-6',
      props: {
        type: 'password',
        label: 'HEADER.CHANGE_PWD.CONFIRM_PWD_LABEL',
        placeholder: 'HEADER.CHANGE_PWD.CONFIRM_PWD_PLACEHOLDER',
        required: true,
      },
    },
  ];

  if (isChangePassword) {
    fieldGroup = [
      {
        key: 'oldPassword',
        type: 'ic1-text',
        className: 'ic1-col-12 ic1-col-lg-6',
        validators: {
          validation: ['PASSWORD_STRENGHT'],
        },
        props: {
          type: 'password',
          label: 'HEADER.CHANGE_PWD.OLD_PWD_LABEL',
          placeholder: 'HEADER.CHANGE_PWD.OLD_PWD_PLACEHOLDER',
          required: true,
        },
      },
      {
        template: '<div class="ic1-col-12 ic1-col-lg-6 filler"></div>',
      },
      ...fieldGroup,
    ];
  }

  const config: FormlyFieldConfig[] = [
    {
      validators: {
        validation,
      },
      fieldGroup,
    },
  ];

  console.log(config);
  return config;
};

export function validCodiceFiscaleValidator(
  control: AbstractControl
): ValidationErrors | null {
  const codice = control.value;
  if (!codice) {
    return null;
  }

  const isValid = CODICE_FISCALE_REGEX.test(codice.toUpperCase());
  return !isValid ? { VALID_CODICE_FISCALE: true } : null;
}

export function validUuidValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value) {
    return null;
  }

  const isValid = UUID_REGEX.test(value);
  return !isValid ? { VALID_UUID: true } : null;
}

// Validatore blando per numeri di telefono: solo cifre, lunghezza 7-15
export function validPhoneNumberValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control?.value;
  // Gestiamo il caso di FormControl con valore oggetto { prefix, number }
  const number: string =
    typeof value === 'object' && value !== null
      ? (value.number ?? '')
      : String(value ?? '');
  if (!number) {
    return null; // lascia required gestire il vuoto
  }
  const isValid = PHONE_NUMBER_REGEX.test(number);
  return !isValid ? { validatePhoneNumber: true } : null;
}
